import React from "react";
import { cn } from "../../../../lib/utils";

const OpeningDirection = ({ methods, isOpen: { OpeningDirection } }) => {
    const { register } = methods;
    return (
        <div
            className={cn(
                "section flex flex-col gap-4  overflow-hidden transition-all h-0 opacity-0",
                {
                    ["h-full opacity-100"]: OpeningDirection.isOpen,
                }
            )}
        >
            <div className="grid grid-cols-2 gap-4">
                <div className="group">
                    <div className=" relative flex items-center justify-center p-4 border border-gray-500 group-has-[:checked]:border-primary">
                        <input
                            className="absolute inset-0 h-full w-full cursor-pointer opacity-0"
                            type="radio"
                            id="opening_direction"
                            {...register("opening_direction")}
                            value="Hung on left"
                        />
                        <span className="text-gray-700 group-has-[:checked]:text-primary">
                            Hung on left
                        </span>
                    </div>
                </div>
                <div className="group">
                    <div className=" relative flex items-center justify-center p-4 border border-gray-500 group-has-[:checked]:border-primary">
                        <input
                            className="absolute inset-0 h-full w-full cursor-pointer opacity-0"
                            type="radio"
                            id="opening_direction"
                            {...register("opening_direction")}
                            value="Hung on right"
                        />
                        <span className="text-gray-700 group-has-[:checked]:text-primary">
                            Hung on right
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OpeningDirection;
